import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

function number(value) {
  return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
}

export default class MarketTicker extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.items = [];
    this.loaded = false;
    this.clearanceFrame = null;
    this.scheduleHeaderClearance = this.scheduleHeaderClearance.bind(this);
    app.request({ method: 'GET', url: `${app.forum.attribute('apiUrl')}/gardensel-markets-ticker` })
      .then((response) => {
        const payload = response.data || {};
        this.items = payload.reference_type === 'official_market_reference' && payload.is_commercial_offer === false ? (payload.items || []) : [];
        this.loaded = true;
        this.syncBodyClass();
        m.redraw();
      })
      .catch(() => {
        this.loaded = true;
        this.items = [];
        this.syncBodyClass();
        m.redraw();
      });
  }

  oncreate() {
    this.syncBodyClass();
    window.addEventListener('resize', this.scheduleHeaderClearance);
    this.scheduleHeaderClearance();
  }

  onupdate() {
    this.syncBodyClass();
    this.scheduleHeaderClearance();
  }

  onremove() {
    document.body.classList.remove('has-market-ticker');
    window.removeEventListener('resize', this.scheduleHeaderClearance);
    if (this.clearanceFrame !== null) window.cancelAnimationFrame(this.clearanceFrame);
  }

  syncBodyClass() {
    document.body.classList.toggle('has-market-ticker', this.items.length > 0);
  }

  scheduleHeaderClearance() {
    if (!this.items.length || this.clearanceFrame !== null) return;

    this.clearanceFrame = window.requestAnimationFrame(() => {
      this.clearanceFrame = null;

      const host = document.getElementById('gardensel-market-ticker');
      const header = document.querySelector('.App-header');
      if (!host || !header) return;

      host.style.setProperty('--market-ticker-header-clearance', '0px');
      const overlap = Math.ceil(header.getBoundingClientRect().bottom - host.getBoundingClientRect().top);
      host.style.setProperty('--market-ticker-header-clearance', Math.max(0, overlap) + 'px');
    });
  }

  item(row, duplicate = false) {
    return <Link
      className="MarketTicker-item"
      href={app.route('gardenselBorsaProduct', { slug: row.slug })}
      tabindex={duplicate ? -1 : 0}
      aria-hidden={duplicate ? 'true' : null}
      title={`${row.reference_label}; ${row.basis_label}, ${row.unit}, ${row.observed_on}. Satış teklifi değildir.`}
    >
      <strong>{row.name}</strong>
      <b>{number(row.reference_price)} {row.unit}</b>
      <small>{row.reference_label}</small>
    </Link>;
  }

  view() {
    if (!this.loaded || !this.items.length) return null;
    return <section className="MarketTicker" aria-label="Gardensel Borsa güncel piyasa referansları">
      <Link className="MarketTicker-brand" href={app.route('gardenselBorsa')}>
        <i className="fas fa-chart-line" aria-hidden="true" />
        <span>Gardensel Borsa</span>
      </Link>
      <div className="MarketTicker-window">
        <div className="MarketTicker-track">
          <div className="MarketTicker-set">{this.items.map((row) => this.item(row))}</div>
          <div className="MarketTicker-set" aria-hidden="true">{this.items.map((row) => this.item(row, true))}</div>
        </div>
      </div>
      <span className="MarketTicker-note">Piyasa referansı · teklif değil</span>
    </section>;
  }
}
